import { jsx, Fragment } from "react/jsx-runtime";
import { Children } from "react";
import { CostcoBox } from "../../../../Util/CostcoBox.js";
const OneThird = ({
  children
}) => {
  return /* @__PURE__ */ jsx(Fragment, { children: Children.map(children, (child, index) => {
    return /* @__PURE__ */ jsx(
      CostcoBox,
      {
        sx: {
          display: "flex",
          flex: {
            md: `calc(33.33% - 21.33px)`,
            xs: "100%"
          },
          maxWidth: {
            md: `calc(33.33% - 21.33px)`,
            xs: "100%"
          }
        },
        children: child
      },
      index
    );
  }) });
};
export {
  OneThird
};
